import { MetricIdentifier } from 'modules/experiments/constants';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { ExperimentVariantBreakdownArray, MetricOption } from 'modules/experiments/types';
import { Dispatch, SetStateAction } from 'react';
import { ExportButton } from './ExportButton';
import { BreakdownHeaderMetricsSection, StyledMultiSelect } from './Styled';

type HeaderMetricSectionProps = {
  options: MetricOption<string>[];
  rows: ExperimentVariantBreakdownArray;
  metricMap: Record<string, MetricIdentifier>;
  selectedMetricsColumn: string[];
  setSelectedMetricsColumn: Dispatch<SetStateAction<string[]>>;
};

export const HeaderMetricSection = ({
  rows,
  metricMap,
  options,
  selectedMetricsColumn,
  setSelectedMetricsColumn,
}: HeaderMetricSectionProps) => {
  const { t } = useExperimentsTranslations();

  return (
    <BreakdownHeaderMetricsSection>
      <StyledMultiSelect
        data-test="variant-breakdown-header-metric-select"
        defaultValues={selectedMetricsColumn}
        categoryLabels={t('variantTable.metrics.title', { returnObjects: true })}
        displayContent={{
          multipleSelectedText: t('variantTable.metrics.multipleSelectedText'),
        }}
        options={options}
        placeholder={t('variantTable.metrics.placeholder')}
        inputContent={{
          filterPlaceholder: t('variantTable.metrics.filterPlaceholder'),
        }}
        emptyStateText={t('variantTable.metrics.emptyStateText')}
        content={{
          clearText: t('variantTable.metrics.clearText'),
          selectAll: t('variantTable.metrics.selectAll'),
          selectNone: t('variantTable.metrics.selectNone'),
        }}
        onSelect={(val) => setSelectedMetricsColumn(val as string[])}
      />
      <ExportButton
        rows={rows}
        metricMap={metricMap}
        metricOptions={options}
        selectedMetricsColumn={selectedMetricsColumn}
      />
    </BreakdownHeaderMetricsSection>
  );
};
